var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTroubleshoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_440_533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 83,
    height: 83
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 8.33325H91.0001V91.0001H8.33325V8.33325Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_440_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.204 38.6061L54.466 37.3467L57.7686 34.0515C59.473 32.351 59.473 29.5659 57.7686 27.8654C56.0644 26.1647 53.2731 26.1647 51.5687 27.8654L47.0042 32.42",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4388 47.5817C72.9464 46.0926 70.5005 46.0926 69.0081 47.5817L63.2089 53.3726C61.7165 54.8618 61.7165 57.2977 63.2089 58.7867C64.7012 60.2758 67.1426 60.2758 68.6352 58.7867L74.4388 52.9958C75.9313 51.5068 75.9313 49.0709 74.4388 47.5817Z",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3885 40.8168C62.8081 41.3959 64.0011 40.2055 64.0195 40.1872C65.673 38.4821 65.6547 35.7383 63.9688 34.0515C62.2646 32.351 59.4731 32.351 57.7688 34.0515L55.4841 36.3311",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7114 77.0512C62.6239 74.9692 63.02 72.8642 63.9091 70.9387L43.8721 50.9416M66.9169 59.7751L71.0072 63.8561C75.899 61.6133 81.91 62.4959 85.9266 66.5034C89.1327 69.7022 90.3441 74.1695 89.5565 78.3243C88.7318 82.6858 86.4289 79.3859 85.9589 78.9172L80.3346 73.3055C78.3679 71.343 75.2035 71.2603 73.1353 73.0619C71.3296 75.1255 71.4126 78.283 73.3793 80.2455L79.0036 85.8571C79.4734 86.3259 82.7807 88.6239 78.4094 89.4465C74.2454 90.2325 69.7681 89.0237 66.5624 85.8249C65.5626 84.823 64.7566 83.7015 64.144 82.5067M40.4451 33.3666L35.4243 28.3524C37.6721 23.4715 36.7876 17.4738 32.771 13.4662C29.5653 10.2674 25.0882 9.05855 20.924 9.84453C16.5527 10.6672 19.86 12.9652 20.3298 13.4339L25.9541 19.0456C27.9208 21.0081 28.0038 24.1656 26.1982 26.229C24.1299 28.0307 20.9655 27.9479 18.9988 25.9855L13.3745 20.3739C12.9047 19.905 10.6016 16.6051 9.77689 20.9668C8.98946 25.1216 10.2007 29.5888 13.4068 32.7876C17.4234 36.7952 23.4343 37.6777 28.3262 35.4349L33.6418 40.7385",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6198 71.9313L38.5659 78.8619C39.6393 79.9329 39.6393 81.6839 38.5659 82.7548L32.3892 88.918C31.3158 89.9888 29.5609 89.9888 28.4877 88.918L11.4309 71.8992C10.3577 70.8282 10.3577 69.0772 11.4309 68.0062L17.6078 61.8432C18.681 60.7722 20.4359 60.7722 21.5093 61.8432L27.6171 67.9375",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5657 78.8621L46.7923 70.6537C49.8739 67.579 50.4726 68.2408 54.1116 68.7602C55.7421 68.9945 58.0683 68.1259 59.9384 66.9769",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0082 41.3959C67.3039 39.6954 64.5126 39.6954 62.8084 41.3959L58.2619 45.932C56.553 47.6372 56.553 50.4177 58.2619 52.1182C59.9662 53.8233 62.7575 53.8233 64.4619 52.1182L69.0082 47.582C70.7171 45.8815 70.7171 43.0963 69.0082 41.3959Z",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8237 45.3761C58.9482 44.1674 56.949 42.3427 54.8946 40.2929L45.862 31.2802C44.9499 30.3703 43.4482 30.3703 42.5318 31.2849L35.0741 38.7257C33.3791 40.417 32.619 42.9035 32.7527 45.1371C32.96 48.5565 31.3661 52.0127 26.6402 56.7235L21.509 61.8434M43.8491 41.6441C43.9272 41.7268 46.9812 44.7695 47.0595 44.8476C49.4777 47.1823 54.3557 49.1952 57.5017 46.9525",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8489 41.6438C46.5433 44.3325 45.7972 49.4341 42.186 53.0372",
    stroke: "#344054",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTroubleshoot);
export default __webpack_public_path__ + "static/media/icon_troubleshoot.2ff435e41821eafe3057138ceadab0d7.svg";
export { ForwardRef as ReactComponent };